import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { Pressable, Text, View } from "react-native";
import { SelecteurPeriodeProps } from "./EnTetePage.types";
import { useMemo } from "react";
import styles from './EnTetePage.styles';
import { capitalize } from "../../lib/generique";

export default function SelecteurPeriode({currentDate, periodGestion, dateDebutRef, dateFinRef, goToNext, goToPrevious}: SelecteurPeriodeProps){
    const { period } = periodGestion || {};

    const dateText = useMemo(() => {
        switch (period) {
            case 'day' :
                return capitalize(currentDate.format('dddd DD MMMM YYYY'));
            case 'week':
                return `Du ${dateDebutRef.format('DD/MM/YYYY')} au ${dateFinRef.format('DD/MM/YYYY')}`;
            case 'month':
                return capitalize(currentDate.format('MMMM YYYY'));
            case 'year':
                return `Année ${currentDate.format('YYYY')}`
            default:
                return ''
        }
    }, [currentDate, dateDebutRef, dateFinRef, period])
    return (
        <>
            <Text style={styles.pageSubtitle}>
                {period !== 'day' && period !== 'week' && `Du ${dateDebutRef.format('DD/MM/YYYY')} au ${dateFinRef.format('DD/MM/YYYY')}`}
            </Text>
            <View style={styles.dateSelector}>
                <Pressable
                    style={styles.dateArrow}
                    onPress={goToPrevious}
                    testID='BT_PREVIOUS'
                >
                    <MaterialCommunityIcons
                        name="chevron-left"
                        size={24}
                        color="#3b82f6"
                    />
                </Pressable>
                 <Text style={styles.dateText}>{dateText}</Text>
                <Pressable
                    style={styles.dateArrow}
                    onPress={goToNext}
                    testID='BT_NEXT'
                >
                    <MaterialCommunityIcons
                        name="chevron-right"
                        size={24}
                        color="#3b82f6"
                    />
                </Pressable>
            </View>
        </>
    );
}
